import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import BackButton from "../../../components/BackButton";
import InputField from "../../../components/InputField";
import AuthCard from "../../../components/AuthCard";
import Button from "../../../components/Button";
import ErrorText from "../../../components/ErrorText";
import FormGroup from "../../../components/FormGroup";
import RequiredLabel from "../../../components/RequiredLabel";
import { sendPasswordResetEmail } from "./services/authServices";
import { showNotification } from "../../../redux/slices/notificationSlice";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const isEmailValid = email.trim() !== "";
  const requiredReason = t("pleaseCompleteRequiredFields", {
    defaultValue: "Please complete all required fields correctly.",
  });

  const handleSubmit = async () => {
    if (!isEmailValid || isSubmitting) return;

    setIsSubmitting(true);
    setError("");
    try {
      await sendPasswordResetEmail(email);
      setSubmitted(true);
      dispatch(
        showNotification({
          message: `${t("resetEmailSent")} ${email}`,
          type: "success",
        })
      );
    } catch (err) {
      setError(t("resetEmailFailed"));
      dispatch(
        showNotification({
          message: t("resetEmailFailed"),
          type: "error",
        })
      );
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="flex flex-col items-center justify-center h-screen bg-gray-50 animate-fade-in">
      <AuthCard>
        <BackButton />
        <h2 className="main-header mb-4 text-center">{t("resetPassword")}</h2>

        {submitted ? (
          <p className="text-center text-green-600">
            {t("resetEmailSent")} <span className="font-semibold">{email}</span>
            .
          </p>
        ) : (
          <>
            <FormGroup>
              <RequiredLabel htmlFor="reset-email" className="mb-2">
                {t("yourEmail")}
              </RequiredLabel>
              <InputField
                id="reset-email"
                type="email"
                placeholder="example@email.com"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
            </FormGroup>
            <ErrorText>{error}</ErrorText>

            <Button
              className="w-full mt-4"
              onClick={handleSubmit}
              disabled={!isEmailValid || isSubmitting}
              disabledReason={!isEmailValid ? requiredReason : ""}
              loading={isSubmitting}
              loadingLabel={t("loading")}
            >
              {t("sendResetLink")}
            </Button>
          </>
        )}
      </AuthCard>
    </div>
  );
}
